<!--<header class="header-panel" [ngClass]="{'patent-plus-design' : contractType == 'p'}">-->
<header class="header-panel">
    <nav class="navbar navbar-expand-lg fixed-top shadow-sm bg-white patent-plus-logo patent-plus-design">
        <div class="header-main-panel" id="navbarToggle">
            <div class="center-panel" *ngIf="logoPath != undefined">
                <a class="navbar-brand">
                    <img id="imgLogo" src={{logoPath}} />
                    <span class="version-text">{{this.appVersion}}</span>
                </a>
            </div>
        </div>
    </nav>
</header>
<div class="modal fade contract-modalV1" id="modalExportDocument" tabindex="-1" role="dialog" aria-labelledby="modalExportDocument" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered model-sm" role="Document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title text-left font-weight-bold" id="modalExportDocumentTitle">{{modalTitle}}</h4>
            </div>
            <div class="modal-body col-sm-12">
                <div class="container-fluid">
                    <div class="row col-sm-12">
                        <div class="col-sm-9" style="margin-top:20px">
                            <h5>{{modalBody}}</h5>
                        </div>
                        <div class="loader"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
